const formatFormListLabel = (text, listSize, showListSize) =>
  `${text}${showListSize && listSize > 0 ? ` (${listSize})` : ''}`

export default formatFormListLabel
